module.exports = __webpack_public_path__ + "static/media/company-profile-ad1.b865ae09.png";